import {classes} from '@bitstillery/common/lib/utils'
import {FieldText, Icon} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {clear_filter} from '@bitstillery/common/lib/filters'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {FieldTextAttrs} from '@bitstillery/common/types/field'
import type {FilterTextState} from '@bitstillery/common/types'

interface FilterTextAttrs {
    className: string
    filter: FilterTextState
    /** Add search suggestion provider - when provided, passes to FieldText */
    search?: FieldTextAttrs['search']
    title?: string
}

export class FilterText extends MithrilComponent<FilterTextAttrs> {
    view(vnode: m.Vnode<FilterTextAttrs>) {
        return (
            <div
                className={classes('c-filter-text', 'filter', 'non-collapsable', vnode.attrs.className, {
                    active: Boolean(vnode.attrs.filter.selection),
                })}
            >
                <div className='title'>
                    <div class='name'>
                        <div class='filter-icon'>
                            <Icon
                                active={Boolean(vnode.attrs.filter.selection)}
                                className='btn-filter-toggle'
                                name={(() => {
                                    if (vnode.attrs.filter.icon) {
                                        return vnode.attrs.filter.icon
                                    }
                                    return vnode.attrs.filter.selection ? 'filterRemove' : 'filterPlus'
                                })()}
                                onclick={(e) => {
                                    e.stopPropagation()
                                    clear_filter(vnode.attrs.filter)
                                }}
                                tip={() =>
                                    vnode.attrs.filter.selection
                                        ? $t('filters.actions.deactivate_filter')
                                        : $t('filters.inactive_filter')
                                }
                            />
                        </div>
                    </div>
                    <FieldText
                        model={vnode.attrs.filter.$input ?? [vnode.attrs.filter, 'input']}
                        onenter={() => {
                            vnode.attrs.filter.selection = vnode.attrs.filter.input
                        }}
                        placeholder={`${$t(vnode.attrs.filter.title)}...`}
                        search={vnode.attrs.search}
                    />
                </div>
                {vnode.attrs.filter.help && <div class='help'>{vnode.attrs.filter.help}</div>}
            </div>
        )
    }
}
